/**
Item: Page where Queries for MySQL and ElasticSearch Requests are placed.
Can be found in Fachadministrator -> Datenabfrage
Name: RequestData
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
// import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import MessageService from '../service/MessageService';
import {TabMenu} from 'primereact/tabmenu';
import {InputTextarea} from 'primereact/inputtextarea';

const elasticHttpMethod = [
  { label: 'GET', value: 'GET' },
  { label: 'POST', value: 'POST' },
  { label: 'PUT', value: 'PUT' },
  { label: 'DELETE', value: 'DELETE' },
];

export default class RequestData extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openRequestDialog = this.openRequestDialog.bind(this);
    this.wrapMessage = this.wrapMessage.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleRequestYes = this.handleRequestYes.bind(this);
    this.handleRequestNo = this.handleRequestNo.bind(this);
    this.messageService = new MessageService();
  }

  getInitialState = () => ({
    url: '',
    httpMethod: 'GET',
    queryType: 'ElasticSearch',
    queryString: '',
    resultString: '',
    requestDialogVisible: false,
    activeItem: null,
    tabItems: [{ label: 'ElasticSearch' }, { label: 'MySQL' }, { label: 'Konsistenz herstellen' }],
  })

  handleSubmit = () => {
    event.preventDefault();
    if (this.validateForm()) {
      this.wrapMessage();
    }
  };

  handleAndReset = (e) => {
    this.resetRequest();
    this.handleChange(e);
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleRequestNo() {
    this.setState({ requestDialogVisible: false });
    this.requestDialogVisible = false;
  }

  handleRequestYes() {
    this.requestDialogVisible = false;
    if (this.validateForm()) {
      return this.wrapMessage();
    }
    return Promise.resolve();
  }

  wrapMessage = async () => {
    const {
      url, queryString, queryType, httpMethod,
    } = this.state;

    let res = null;

    if (queryType === 'ElasticSearch') {
      res = await this.messageService.postJSonDebugQuery(
        url,
        queryString.replaceAll(/\s/g, ''),
        queryType,
        httpMethod,
      );
    } else if (queryType === 'MySQL') {
      res = await this.messageService.postJSonDebugQuery(
        url,
        queryString,
        queryType,
        httpMethod,
      );
    } else {
      res = await this.messageService.writeTimeslices();
    }

    if (res !== undefined) {
      this.httpStatus = res.status;
      this.httpStatusText = res.statusText;

      if (queryType === 'ElasticSearch') {
        this.setState({
          resultString: `JSON Format: \n${JSON.stringify(res.data, null, 2)}`,
        });
      } else {
        this.setState({
          resultString: res.data.toString(),
        });
      }
    } else {
      this.httpStatus = '503';
      this.httpStatusText = 'Dienst nicht verfügbar';
      this.setState({
        resultString: 'Keine Verbindung zum Server!',
        requestDialogVisible: false,
      });
    }
  };

  resetRequest = () => {
    this.setState(this.getInitialState());
    this.httpStatus = '';
    this.httpStatusText = '';
  }

  // renders the footer for the request dialog
  requestFooter() {
    return (
      <div>
        <Button
          label="Ja"
          id="yes"
          type="button"
          icon="pi pi-check"
          onClick={this.handleRequestYes}
        />
        <Button
          label="Nein"
          id="no"
          type="button"
          icon="pi pi-times"
          onClick={this.handleRequestNo}
          className="p-button-danger"
        />
      </div>
    );
  }

  openRequestDialog() {
    event.preventDefault();
    this.setState({ requestDialogVisible: true });
    this.requestDialogVisible = true;
  }

  validateForm() {
    const { url, queryString, queryType } = this.state;

    if (queryType === 'ElasticSearch' && url.length === 0) {
      return false;
    }
    if (queryType === 'MySQL' && queryString.length <= 1) {
      return false;
    }
    return true;
  }

  renderRequestDialog() {
    return this.state.queryType !== 'Konsistenz herstellen' ? (
      <Dialog
        header="Query absenden"
        visible={this.requestDialogVisible}
        style={{ width: '40vw' }}
        footer={this.requestFooter()}
        onHide={this.handleRequestNo}
        modal
      >
        <p>Sind Sie sich sicher, dass Sie die Abfrage absenden möchten?</p>
      </Dialog>
    ) : (
      <Dialog
        header={this.state.queryType}
        visible={this.requestDialogVisible}
        style={{ width: '40vw' }}
        footer={this.requestFooter()}
        onHide={this.handleRequestNo}
        modal
      >
        <p>Sind Sie sich sicher, dass Sie die Aktion ausführen möchten?</p>
      </Dialog>
    );
  }

  renderElkOptions() {
    const { queryType, httpMethod, url } = this.state;
    if (queryType === 'ElasticSearch') {
      return (
        <>
          <div className="p-col-2">
            <Dropdown
              value={httpMethod}
              options={elasticHttpMethod}
              onChange={(e) => { this.setState({ httpMethod: e.value }); }}
              placeholder={httpMethod}
            />
          </div>
          <div className="p-col-6">
            <InputText id="in" value={url} name="url" onChange={(e) => this.handleChange(e)} placeholder="/_cat/indices/hs_entw_202101_hsawdb_*" />
          </div>
        </>
      );
    }
    return undefined;
  }

  render() {
    const role = sessionStorage.getItem('role');
    const group = sessionStorage.getItem('group');
    const isAdmin = role === 'GROUP_ADMIN';
    const isSysAdmin = role === 'SYSTEM_ADMIN';
    const isSuperAdmin = role === 'SUPER_SUBJECT_ADMIN';
    const isStBA = group === 'StBA';
    if (!(isSysAdmin || isSuperAdmin || (isAdmin && isStBA))) {
      window.location.replace('./');
      return null;
    }
    const { queryType, queryString, resultString } = this.state;

    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-lg-12">
          <form
            ref={this.form}
            onSubmit={() => {
              this.openRequestDialog();
            }}
          >
            <Card title="Query-Eingabe">
              <div className="p-grid" style={{ alignItems: 'center' }}>
                <div className="p-col-12">
                  <TabMenu
                    model={this.state.tabItems}
                    activeItem={this.state.activeItem}
                    onTabChange={(e) =>
                      this.setState({
                        activeItem: e.value,
                        queryType: e.value.label,
                        queryString: '',
                      })
                    }
                  />
                </div>
                {queryType !== 'Konsistenz herstellen' && (
                  <>
                    {this.renderElkOptions()}
                    <div
                      className={`p-col-${
                        queryType !== 'ElasticSearch' ? 12 : 4
                      }`}
                      style={{ textAlign: 'right' }}
                    >
                      <p style={{ display: 'inline' }}>HTTP Status: </p>
                      <p
                        style={{
                          display: 'inline',
                          color: this.httpStatus === 200 ? 'green' : 'red',
                        }}
                      >
                        {this.httpStatusText}-{this.httpStatus}
                      </p>
                    </div>
                    <div className="p-col-12">
                      <InputTextarea
                        placeholder="<QUERY>"
                        rows={5}
                        cols={30}
                        value={queryString}
                        onChange={(e) =>
                          this.setState({
                            queryString: e.target.value
                          })
                        }
                        autoResize
                      />
                    </div>
                  </>
                )}
              </div>
              <div className="p-grid p-fluid">
                <div style={{ width: '160px' }} className="p-col-12 p-lg-3">
                  <Button
                    className="p-button-success"
                    type="submit"
                    id="submit"
                    label="Absenden"
                    disabled={!this.validateForm()}
                    icon="pi-md-check"
                    tooltipOptions={{ position: 'bottom' }}
                  />
                </div>
                {queryType !== 'Konsistenz herstellen' && (
                  <div style={{ width: '160px' }} className="p-col-12 p-lg-3">
                    <Button
                      icon="pi-md-cancel"
                      id="cancel"
                      type="button"
                      label="Zurücksetzen"
                      onClick={this.resetRequest}
                    />
                  </div>
                )}
              </div>
            </Card>
            {this.renderRequestDialog()}
          </form>
        </div>
        <div className="p-col-12 p-lg-12">
          <Card title="Ergebnis">
            <br />
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-lg-12">
                <p style={{ whiteSpace: 'pre-line' }}>{resultString}</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    );
  }
}
